const translations = {
    breadCrumbsHome: {
        type: 'text',
        defaultValue: 'Strona główna',
    },
    breadCrumbsContact: {
        type: 'text',
        defaultValue: 'Kontakt',
    },
    contactFormHeaderOne: {
        type: 'text',
        defaultValue: 'Masz pytanie?',
    },
    contactFormHeaderTwo: {
        type: 'text',
        defaultValue: 'Napisz do nas',
    },
    contactFormDescription: {
        type: 'text',
        defaultValue: 'Wyślij nam wiadomość. Odpowiemy tak szybko, jak to będzie możliwe.        ',
    },
    inputsNameLabel: {
        type: 'text',
        defaultValue: 'Imię i Nazwisko',
    },
    inputsPhoneLabel: {
        type: 'text',
        defaultValue: 'Numer telefonu',
    },
    inputsEmailLabel: {
        type: 'text',
        defaultValue: 'Adres e-mail',
    },
    inputsEmailPlaceholder: {
        type: 'text',
        defaultValue: 'E-mail',
    },
    inputsMessageLabel: {
        type: 'text',
        defaultValue: 'Wiadomość',
    },
    inputsMessagePlaceholder: {
        type: 'text',
        defaultValue: 'Napisz jakiej pomocy szukasz',
    },
    submitButton: {
        type: 'text',
        defaultValue: 'Wyślij',
    },
    contactInfoHeader: {
        type: 'text',
        defaultValue: 'Kontakt',
    },
    contactInfoPhone: {
        type: 'text',
        defaultValue: '+48 669 510 131',
    },
    contactInfoEmail: {
        type: 'text',
        defaultValue: 'kontakt@mindteacher.pl',
    },
    contactInfoSiteName: {
        type: 'text',
        defaultValue: 'MINDTEACHER',
    },
    contactInfoAddress: {
        type: 'text',
        defaultValue: 'ul. Biała 4 lok. 81, 00-895 Warszawa',
    },
    contactInfoTaxId: {
        type: 'text',
        defaultValue: 'NIP: 5273027992',
    },
    messageSentHeader: {
        type: 'text',
        defaultValue: 'Twoja wiadomość została wysłana',
    },
    messageSentSubheader: {
        type: 'text',
        defaultValue: 'Wkrótce skontaktujemy się z Tobą.',
    },
    returnToHomeButton: {
        type: 'text',
        defaultValue: 'Wróć do strony głównej',
    },
    returnToFormButton: {
        type: 'text',
        defaultValue: 'Wróć do formularza',
    },
};

export default translations;
